module.exports = __webpack_public_path__ + "img/bg2.9a7035ad.png";